import React, { useState, useEffect, useContext } from "react";
import { APIContext } from "src/components/Contexts/APIContext"
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CloseIcon from '@mui/icons-material/Close';
import QaiChallengeFilterViewModel from "./ViewModels/QaiChallengeFilterViewModel";
import getActiveFilterDateRangeFlag from "../../Utilities/DateRange";
import { QaiScorecardChallengeQuestionViewModel } from "./ViewModels/QaiScorecardChallengeQuestionsViewModel";

interface IQaiChallengePageHeaderProps {
    handleChallengeClose: () => void
    questionViewModel: QaiScorecardChallengeQuestionViewModel
    filters: QaiChallengeFilterViewModel
}

export default function QaiChallengePageHeader(
    {
        handleChallengeClose,
        questionViewModel,
        filters
    }: IQaiChallengePageHeaderProps) {
    const { get } = useContext(APIContext);
    const [dateRange, setDateRange] = useState('');

    useEffect(() => {
        get(
            'QaiScorecardChallenge',
            `GetDateRangeForDisplay?dateRangeFlag=${getActiveFilterDateRangeFlag(filters)}`,
            (data) => setDateRange(data))
    }, [])

    return (
        <Toolbar sx={{ backgroundColor: 'rgb(245, 245, 245)', borderBottom: 'solid 1px rgb(192, 192, 192)' }}>
            <IconButton
                edge="start"
                color="primary"
                onClick={handleChallengeClose}
                aria-label="close"
                sx={{ marginRight: 2 }}
            >
                <CloseIcon />
            </IconButton>
            <Grid container spacing={6}>
                <Grid>
                    <Typography><b>Template name: </b>{questionViewModel.templateName}</Typography>
                    <Typography><b>Section title: </b>{questionViewModel.sectionTitle}</Typography>
                </Grid>
                <Grid>
                    <Typography><b>Question text: </b>{questionViewModel.questionText}</Typography>
                    <Typography><b>Date range: </b> {dateRange}</Typography>
                </Grid>
            </Grid>
        </Toolbar>
    )
}